import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWidgets from "@/components/FloatingWidgets";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Commodities from "@/pages/Commodities";
import Industries from "@/pages/Industries";
import Services from "@/pages/Services";
import SupplierRegistration from "@/pages/SupplierRegistration";
import BuyerRegistration from "@/pages/BuyerRegistration";
import RequestQuote from "@/pages/RequestQuote";
import Contact from "@/pages/Contact";
import FastTrack from "@/pages/FastTrack";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SectorLanding from "@/pages/SectorLanding";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname === "/login" || pathname === "/admin";

  return (
    <>
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/services" element={<Services />} />
          <Route path="/supplier-registration" element={<SupplierRegistration />} />
          <Route path="/buyer-registration" element={<BuyerRegistration />} />
          <Route path="/quote" element={<RequestQuote />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/fasttrack" element={<FastTrack />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/cnc-machining-sourcing-india" element={<SectorLanding sectorKey="cnc-machining" />} />
          <Route path="/precision-turned-components-india" element={<SectorLanding sectorKey="precision-turned" />} />
          <Route path="/forging-sourcing-india" element={<SectorLanding sectorKey="forging" />} />
          <Route path="/casting-sourcing-india" element={<SectorLanding sectorKey="casting" />} />
          <Route path="/sheet-metal-fabrication-india" element={<SectorLanding sectorKey="sheet-metal" />} />
          <Route path="/metal-stamping-india" element={<SectorLanding sectorKey="metal-stamping" />} />
          <Route path="/injection-molding-india" element={<SectorLanding sectorKey="injection-molding" />} />
          <Route path="/industrial-engineering-components-india" element={<SectorLanding sectorKey="industrial-components" />} />
          <Route path="/privacy" element={<Legal variant="privacy" />} />
          <Route path="/terms" element={<Legal variant="terms" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <FloatingWidgets />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Shell />
          </SmoothScroll>
          <Toaster position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
